import { RowType, TableListProps } from 'app/components/ChakraTableList/types';
import { useMemo } from 'react';
import {
  getCustomRow,
  getRowSum,
  getSubheaderRow,
} from 'app/components/ChakraTableList/utils';
import {
  rowHeights,
  subheaderWhitespace,
} from 'app/components/ChakraTableList/constants';

export const useListContainerHeight = ({
  loadingOptions,
  rows,
  noHeader,
  summaryRows = 0,
  dragCorrectionDistance = 0,
  regularRowHeight,
}: {
  loadingOptions: TableListProps['loadingOptions'];
  rows: TableListProps['rows'];
  noHeader?: boolean;
  summaryRows?: number;
  dragCorrectionDistance?: number;
  regularRowHeight: number;
}) => {
  const { loading, loadingMore, repeat = 6, withSubheader } =
    loadingOptions || {};

  const subheadersHeight = useMemo(
    () =>
      rows
        .filter(getSubheaderRow)
        .map((row) =>
          row.height ? row.height + subheaderWhitespace : rowHeights.subheader
        )
        .reduce((a, b) => a + b, 0),
    [rows]
  );

  const regularRows = useMemo(
    () =>
      rows.filter((row) =>
        row.type
          ? ![RowType.SUBHEADER, RowType.CUSTOM_CONTENT].includes(row.type)
          : true
      ),
    [rows]
  );

  const customRowsHeight = useMemo(
    () => rows.filter(getCustomRow).reduce(getRowSum, 0),
    [rows]
  );

  let rowsCount = regularRows.length;
  if (loading) {
    rowsCount = repeat;
  } else if (loadingMore) {
    rowsCount = repeat + rowsCount;
  }

  return (
    rowsCount * regularRowHeight +
    summaryRows * rowHeights.regular +
    (noHeader ? 0 : rowHeights.header) +
    (withSubheader ? rowHeights.subheader : 0) +
    subheadersHeight +
    customRowsHeight +
    dragCorrectionDistance
  );
};
